/*eslint new-cap:0 */
export default class Connector {
  constructor(autoTargetView, searchBidView) {
    autoTargetView.options.defaultBid = searchBidView.viewModel.SearchBid();

    searchBidView.viewModel.SearchBid.subscribe((bid) => {
      autoTargetView.trigger('update:bid', bid);
    });
  }
}
